import { specialFont } from "../../Infrastructure/Theme/fontFamily";

export const styles = {
  typoHeading: {
    fontWeight: "400",
    fontSize: "40px",
    fontFamily: `${specialFont}`,
    pt: 4,
    pb: 5,
  },
  typoDescription: {
    pr: { sm: 5 },
    pl: { sm: 5 },
    fontWeight: "400",
    fontSize: "20px",
    pb: 3,
  },
  descOne: {
    pr: 5,
    pl: 5,
    fontWeight: "bold",
    fontSize: "24px",
    pb: 2,
  }
};
